import { Context } from "@nuxt/types";
import { restrictedPagesWhenAuthEnum } from "~/enums/restrictedPagesEnum";
import { COOKIES } from "~/helpers/constants";

export default function isNotAuthenticatedMiddleware(context: Context) {
  // @ts-ignore
  const { app, redirect, i18n, $config } = context;
  const { localePath, $cookies } = app;

  const isAuthenticated =
    $cookies.get(COOKIES.USER) === COOKIES.CURRENT_USER_ID &&
    !!$cookies.get(COOKIES.USER_DATA);

  const isOnRestrictedPages = () => {
    const restrictedPages = Object.values(restrictedPagesWhenAuthEnum).map(
      (page) => i18n.t(`PAGES.${page}`)
    );

    let isOnRestrictedPage: Boolean = false;

    restrictedPages.forEach((page) => {
      if (context.route.path == localePath(page)) {
        isOnRestrictedPage = true;
      }
    });
    return isOnRestrictedPage;
  };

  if (isAuthenticated && isOnRestrictedPages()) {
    const localeCode = i18n.localeProperties.code;

    redirect(`${$config.productionURL}/${localeCode}`);
  }
}
